import { updateObject } from "../../../common/util/UpdateObject";
import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { GeoCalcState } from "../../types";
import Logger from "../../../common/util/Logger";
import GeoCalculationItem from "../../dto/GeoCalculationItem";

const logger = new Logger();

export const removeGeoCalculationReducer: IPartialReducer<GeoCalcState> = (state, action) => {
    logger.info(`removing geoCalculation: ${action.geoCalculation}`);
    const treeItemsVisualisedBefore = state.items ? state.items : [];
    treeItemsVisualisedBefore[0].children = treeItemsVisualisedBefore[0].children.filter(
        (calc: GeoCalculationItem) => calc.id !== action.geoCalculation
    );

    logger.info(`removing geoCalculation '${action.geoCalculation}' geometry`);
    const featureLayer = state.featureLayer;
    const textLayer = state.textLayer;

    if (featureLayer && textLayer) {
        featureLayer.features[0].features = featureLayer.features[0].features.filter(
            (feat) => feat.calculationId !== action.geoCalculation
        );
        textLayer.features[0].features = textLayer.features[0].features.filter(
            (feat) => feat.calculationId !== action.geoCalculation
        );
    }

    return updateObject(state, {
        featureLayer: featureLayer,
        textLayer: textLayer,
        items: [...treeItemsVisualisedBefore],
    });
};
